// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "rescript-classnames/src/Cn.bs.js";
import * as BsCss from "../../bindings/BsCss.bs.js";
import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as Theme from "../../css/Theme.bs.js";
import * as React from "react";
import * as Belt_Option from "@rescript/std/lib/es6/belt_Option.js";
import * as ErrorFieldText from "./ErrorFieldText.bs.js";
import * as JsxRuntime from "react/jsx-runtime";

var disabledInput = Curry._1(BsCss.style, {
      hd: BsCss.important(BsCss.color(Theme.Color.midGrey)),
      tl: /* [] */0
    });

var Styles = {
  disabledInput: disabledInput
};

var make = React.memo(function (props) {
      var error = props.error;
      var readOnly = props.readOnly;
      var disabled = props.disabled;
      var placeholder = props.placeholder;
      return JsxRuntime.jsxs(JsxRuntime.Fragment, {
                  children: [
                    JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsx("input", {
                                  ref: props.inputRef,
                                  defaultValue: props.defaultValue,
                                  className: Cn.make([
                                        Belt_Option.getWithDefault(props.inputClassName, ""),
                                        Belt_Option.getWithDefault(disabled, false) || Belt_Option.getWithDefault(readOnly, false) ? disabledInput : ""
                                      ]),
                                  autoComplete: props.autoComplete,
                                  autoFocus: props.autoFocus,
                                  disabled: disabled,
                                  maxLength: props.maxLength,
                                  minLength: props.minLength,
                                  name: props.name,
                                  pattern: props.pattern,
                                  placeholder: placeholder,
                                  readOnly: readOnly,
                                  type: props.type_,
                                  onKeyDown: props.onKeyDown,
                                  onFocus: props.onFocus,
                                  onBlur: props.onBlur,
                                  onChange: props.onChange
                                }),
                            JsxRuntime.jsx("label", {
                                  children: Belt_Option.getWithDefault(props.floatingLabel, placeholder)
                                }),
                            Belt_Option.getWithDefault(props.children, null)
                          ],
                          className: Cn.make([
                                Belt_Option.getWithDefault(props.containerClassName, ""),
                                "inputContainer",
                                Belt_Option.getWithDefault(error, "") !== "" ? "error" : ""
                              ])
                        }),
                    JsxRuntime.jsx(ErrorFieldText.make, {
                          error: error
                        })
                  ]
                });
    });

export {
  Styles ,
  make ,
}
/* disabledInput Not a pure module */
